import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { PosthogService } from '../../services/posthog.service';
import { ToHtmlPipe } from '../../utilities/to-htmlpipe/to-html.pipe';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';
import { TalkToSalesButtonComponent } from '../talktosalesButton/talktosalesButton.component';

@Component({
  selector: 'app-common-getstarted',
  templateUrl: './getstarted.component.html',
  styleUrls: ['./getstarted.component.scss'],
  imports: [CommonModule, TalkToSalesButtonComponent, UrlParamsPipe, ToHtmlPipe],
})
export class CommonGetstartedComponent implements OnInit, OnDestroy {
  @Input() getStartedData: any;
  @ViewChild('registerLink') registerLink: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute,
    private posthogService: PosthogService
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  _getStartedData: any;

  ngOnInit(): void {
    this._getStartedData = this.getStartedData;
  }
  ngOnChanges(): void {
    this._getStartedData = this.getStartedData;
  }

  onGetStartedClick(): void {
    this.posthogService.captureCTAClick('get_started', 'bottom', {
      ctaText: this._getStartedData?.button1?.text,
      destinationUrl: this._getStartedData?.button1?.url
    });
  }
}
